import { Box } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { AsyncContent } from '~/components/AsyncContent';
import { BadgeItem } from '~/components/MyWorkspace/BadgeItem';
import { People } from '~/services/Http';

import { getMomentOfAnniversary } from '../../services';

import { useSxStyles } from './useStyles';

export interface Props {
  teamAnniversariesLoading: boolean;
  teamAnniversaries: People.AnniversaryDto[];
  failedToLoadTeamAnniversaries: boolean;
  containerWidth: number;
  containerHeight: number;
  noOfFittingColumns: number;
  noOfFittingRows: number;
}

export const Content: React.FC<Props> = ({
  teamAnniversariesLoading,
  teamAnniversaries,
  failedToLoadTeamAnniversaries,
  containerWidth,
  containerHeight,
  noOfFittingColumns,
  noOfFittingRows,
}) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();

  const badgeItemWidth = containerWidth / noOfFittingColumns;
  const badgeItemHeight = containerHeight / noOfFittingRows;

  return (
    <AsyncContent
      isLoading={teamAnniversariesLoading}
      failedToLoad={failedToLoadTeamAnniversaries}
      noData={!teamAnniversaries.length}
      noDataMessage={t('teamAnniversariesEmpty')}
      customSxStyles={{ errorMessage: sxStyles.errorMessage }}
    >
      <Box data-cy="list" sx={sxStyles.list}>
        {teamAnniversaries
          .slice(0, noOfFittingColumns * noOfFittingRows)
          .map((anniversary) => {
            const upcomingYears = anniversary.years + 1;
            return (
              <Box
                key={`${anniversary.employee.id}-${anniversary.type}`}
                sx={{ width: badgeItemWidth, height: badgeItemHeight }}
                data-cy="list-item"
              >
                <BadgeItem
                  href={`/page-ui2-redirect?empId=${anniversary.employee.id}&area=people`}
                  avatarProps={{
                    alt: anniversary.employee.firstName,
                    src: anniversary.employee.profilePic,
                  }}
                  badgeProps={{
                    badgeContent: anniversary.years,
                    children: undefined,
                    color:
                      anniversary.type !== People.AnniversaryTypeEnum.BIRTHDAY
                        ? 'primary'
                        : 'secondary',
                  }}
                  sx={sxStyles.badgeItemRoot}
                  primaryText={
                    anniversary.type === People.AnniversaryTypeEnum.BIRTHDAY
                      ? `${anniversary.employee.firstName} ${upcomingYears} ${t(
                          'birthday',
                        )}`
                      : `${anniversary.employee.firstName} ${upcomingYears} ${t(
                          'anniversary',
                        )}`
                  }
                  secondaryText={getMomentOfAnniversary(anniversary.date, t)}
                />
              </Box>
            );
          })}
      </Box>
    </AsyncContent>
  );
};
